import {scribeArtifactsQueryKey} from '@github-ui/scribe-artifacts'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useMemo} from 'react'

type IssueArtifactsAliveNotification = {
  wait?: number
  issue_artifacts_updated?: true
}

type IssueArtifactsAliveUpdatesProps = {
  channel?: string | null
  resourceId: number
}

export function IssueArtifactsAliveUpdates({channel, resourceId}: IssueArtifactsAliveUpdatesProps) {
  const queryFilters = useMemo(() => ({queryKey: scribeArtifactsQueryKey('issue', resourceId)}), [resourceId])

  useInvalidateOnAliveUpdate<IssueArtifactsAliveNotification>(channel, queryFilters, {
    filter: update => update.issue_artifacts_updated === true,
  })

  return null
}
